<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

.content {
  padding-bottom: 40px;
}
</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Unpacking Gender Roles</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Workshop, discussion</p>
        <p><i>Unpacking Gender Roles</i> was an informal meet-up to discuss our graduation processes under the same umbrella, through the lens of gender. In our work, we explored strategies to unpack, decontextualize and infiltrate gender structures in our daily lives. During this session, we talked about public speaking and listening, visual gender representations in food culture, and how social media amplifies some voices while silencing others. The intention of this event was to make our processes public, and invite others to exchange feedback.</p>
        <p>This session was created in collaboration with Angeliki Diakrousi and Natasha Berting.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/unpacking/un2.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/unpacking/un1.png"></b-img>
      </b-col>

      <b-col md="4">
      <b-img class="img-fluid" src="media/unpacking/unpacking.png"></b-img>

      </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'UnpackingPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
